// extracted by mini-css-extract-plugin
export default {"switch_list":"tile-switch-list_switch_list__7CNFA","switch_circle":"tile-switch-list_switch_circle__5uavq","switch_circle_active":"tile-switch-list_switch_circle_active__PPPDg"};